<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-3" d="M67.62,80.93H21.26c-1.08,0-1.96-.88-1.96-1.96V14.42c0-1.08,.88-1.96,1.96-1.96h46.36c1.08,0,1.96,.88,1.96,1.96V78.97c0,1.08-.88,1.96-1.96,1.96Zm-44.4-3.92h42.44V16.38H23.22v60.62Z"/>
  <g>
    <rect class="cls-1" x="33.77" y="10.82" width="21.35" height="8.84"/>
    <path class="cls-2" d="M55.12,21.62h-21.35c-1.08,0-1.96-.88-1.96-1.96V10.82c0-1.08,.88-1.96,1.96-1.96h21.35c1.08,0,1.96,.88,1.96,1.96v8.84c0,1.08-.88,1.96-1.96,1.96Zm-19.39-3.92h17.43v-4.92h-17.43v4.92Z"/>
  </g>
  <path class="cls-4" d="M56.92,32.01H31.97c-.93,0-1.68-.75-1.68-1.68s.75-1.68,1.68-1.68h24.95c.93,0,1.68,.75,1.68,1.68s-.75,1.68-1.68,1.68Z"/>
  <path class="cls-4" d="M56.92,46.95H31.97c-.93,0-1.68-.75-1.68-1.68s.75-1.68,1.68-1.68h24.95c.93,0,1.68,.75,1.68,1.68s-.75,1.68-1.68,1.68Z"/>
  <g>
    <circle class="cls-1" cx="64.53" cy="74.97" r="9.41"/>
    <path class="cls-2" d="M64.53,85.78c-5.96,0-10.81-4.85-10.81-10.81s4.85-10.81,10.81-10.81,10.81,4.85,10.81,10.81-4.85,10.81-10.81,10.81Zm0-18.82c-4.42,0-8.01,3.59-8.01,8.01s3.59,8.01,8.01,8.01,8.01-3.59,8.01-8.01-3.59-8.01-8.01-8.01Z"/>
  </g>
  <path class="cls-4" d="M56.92,61.89H31.97c-.93,0-1.68-.75-1.68-1.68s.75-1.68,1.68-1.68h24.95c.93,0,1.68,.75,1.68,1.68s-.75,1.68-1.68,1.68Z"/>
  <path class="cls-3" d="M62.69,79.52c-.28,0-.56-.1-.77-.31l-2.81-2.67c-.45-.43-.47-1.14-.04-1.58,.43-.45,1.13-.47,1.58-.04l2.05,1.95,5.98-5.5c.46-.42,1.16-.39,1.58,.07,.42,.46,.39,1.16-.07,1.58l-6.76,6.21c-.21,.2-.49,.3-.76,.3Z"/>
</svg>
</template>

<script>
export default {
    name: "TotalsDashboardIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #115c72;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #cfeae0;
  }
</style>